import React from "react";
import Translate from "react-translate-component";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const AccountUpgrade = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    if (op[1].upgrade_to_lifetime_member) {
      return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].account_to_upgrade), " \xA0", /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.lifetime_upgrade_account"
      }));
    } else {
      return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].account_to_upgrade), " \xA0", /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.annual_upgrade_account"
      }));
    }
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: op[1].upgrade_to_lifetime_member ? "operation.lifetime_upgrade_account" : "operation.annual_upgrade_account",
      keys: [{
        type: "account",
        value: op[1].account_to_upgrade,
        arg: "account"
      }]
    }));
  }
};